import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { CampaignData } from "../../../../../EngagementInterfaces";
import { DEFAULT_FROM_EMAIL, DEFAULT_REPLY_TO } from "../AiCampaignConstants";
import type { CampaignSenderDetails } from "../AiCampaignTypes";

export const useCampaignSenderDetails = (
  campaignData: Partial<CampaignData>
): CampaignSenderDetails => {
  const { t } = useTranslation();
  const { companyNameEngagements, sendTo, excludeList } = campaignData;

  return useMemo(
    () => ({
      fromName:
        companyNameEngagements ||
        localStorage.getItem("company_name") ||
        t("campaignFlow.common.defaultCompany"),
      fromEmail: DEFAULT_FROM_EMAIL,
      replyTo: DEFAULT_REPLY_TO,
      recipients: sendTo ?? [],
      exclusions: excludeList ?? [],
    }),
    [companyNameEngagements, excludeList, sendTo, t]
  );
};
